module.exports = __webpack_public_path__ + "img/zhhys.4c3fafef.svg";